import { Component } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { Sponsored } from '../../models/sponsored/sponsored.model';

@Component({
    selector: 'swb-sponsored-list',
    templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class SponsoredListComponent extends ListBase<Sponsored> {
    public url = 'sponsored';
    public routePrefix = 'sponsored';

    protected hasPagination = false;

    constructor(
        _apiService: ApiService,
        _communicationService: CommunicationService
    ) {
        super(
            _apiService,
            _communicationService
        );
    }
}
